import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'
import useFilteredFlightDeals from 'home/hooks/useFilteredFlightDeals'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Group from 'components/utils/Group'
import FlightDealsCarousel from './FlightDealsCarousel/FlightDealsCarousel'
import Image from 'components/Common/Image'
import Heading from 'LuxKit/Typography/Heading'
import LayoutContainer from 'components/Common/LayoutContainer'
import { HOME_PAGE_FLIGHT_DEALS_THRESHOLD } from 'hooks/Flights/useCampaignsOrDeals'

interface Props {
  flightDeals: Array<App.FlightDeal>
  flightDealsLoading: boolean
}

function FlightDeals(props: Props) {
  const { flightDeals, flightDealsLoading } = props
  const intl = useIntl()
  const {
    filteredFlightDeals,
    airports,
    defaultAirport,
    selectedAirport,
    setAirport,
    hasMultipleAirlines,
  } = useFilteredFlightDeals({ flightDeals })

  const headingText = hasMultipleAirlines
    ? intl.formatMessage({
        id: 'Z3pF3vo4p1O_IwJI0VZy',
        defaultMessage: 'Flights sale with our partner airlines',
        description: 'Flight deals heading when multiple airlines are available',
      })
    : intl.formatMessage({
        id: 'kmYyVLKcsy5Rv8D5LZND',
        defaultMessage: 'Flights sale',
        description: 'Section heading for the flights sale deals on the flights discovery page',
      })

  const carouselTitle = useMemo(
    () =>
      airports.length > 1
        ? intl.formatMessage({
            id: '3OSAG5By2rlJo1yb--yT',
            defaultMessage: 'Limited-time flight offers from',
            description: 'Flight deals carousel title when multiple airports are available',
          })
        : intl.formatMessage({
            id: '_nYB-NtPkeFUrJHGlXfD',
            defaultMessage: 'Limited-time flight offers',
            description: 'Flight deals carousel title when single airport is available',
          }),
    [intl, airports.length],
  )

  if (filteredFlightDeals.length < HOME_PAGE_FLIGHT_DEALS_THRESHOLD) {
    return null
  }

  return (
    <VerticalSpacer gap={16}>
      <LayoutContainer>
        {!!filteredFlightDeals.length && (
          <Group direction="horizontal" gap={8} verticalAlign="end">
            <Heading variant="heading4">{headingText}</Heading>
            {!hasMultipleAirlines && <Image image={filteredFlightDeals[0].carrier.logo} width={100} alt={`Logo of ${filteredFlightDeals[0].carrier.name}`} />}
          </Group>
        )}
      </LayoutContainer>

      <FlightDealsCarousel
        title={carouselTitle}
        onAirportChange={setAirport}
        airports={airports}
        flightDeals={flightDeals}
        defaultAirport={defaultAirport}
        selectedAirport={selectedAirport}
        loading={flightDealsLoading}
        showLookingForAFlight
        showViewAll
      />
    </VerticalSpacer>
  )
}

export default FlightDeals
